import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'

interface InactivityWarningModalProps {
  open: boolean
  onExtendSession: () => void
  onLogout: () => void
  secondsRemaining: number
}

export const InactivityWarningModal = ({
  open,
  onExtendSession,
  onLogout,
  secondsRemaining,
}: InactivityWarningModalProps) => {
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown>
      <DialogTitle variant="h3">Je sessie verloopt binnenkort</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Je bent al een tijdje inactief geweest. Om je gegevens te beschermen, word je automatisch
          uitgelogd over:
        </Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            color: 'error.main',
            my: 2,
          }}>
          {formatTime(secondsRemaining)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Klik op &quot;Blijf ingelogd&quot; om je sessie te verlengen en verder te werken.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2.5 }}>
        <Button
          onClick={onLogout}
          variant="outlined"
          disabled={secondsRemaining === 0}>
          Uitloggen
        </Button>
        <Button
          onClick={onExtendSession}
          variant="contained"
          disabled={secondsRemaining === 0}
          autoFocus>
          Blijf ingelogd
        </Button>
      </DialogActions>
    </Dialog>
  )
}
